export default __webpack_public_path__ + "static/media/pig.1e6b97d2.png";